export default __webpack_public_path__ + "static/media/market-size.19b185de.svg";